// extracted by mini-css-extract-plugin
export var wrapper = "langSelector-module--wrapper--1f12e";